export const BRIGHCOVE_ACCOUNT_ID = '6415627493001';
